module.exports = __webpack_public_path__ + "static/img/33.a26b4f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/33.jpg
// module id = P4hn
// module chunks = 0